import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LessonResultsStore, CurrentCellData, ProblemId, StudentId } from './typings';

const initialState: LessonResultsStore = {
    shouldShowAttempts: false,
    shouldShowTime: false,
    shouldShowPoints: false,
    shouldShowDescriptionPopup: false,
    cellDescriptionData: null,
    isStatsExpanded: false,
    studentsOnline: {},
};

// Параметры нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars */
const slice = createSlice({
    name: 'LESSON_RESULTS',
    initialState: initialState,
    reducers: {
        setShouldShowAttempts: (state, action: PayloadAction<boolean>) => {
            state.shouldShowAttempts = action.payload;
        },
        setShouldShowTime: (state, action: PayloadAction<boolean>) => {
            state.shouldShowTime = action.payload;
        },
        setShouldShowPoints: (state, action: PayloadAction<boolean>) => {
            state.shouldShowPoints = action.payload;
        },
        clearState: () => initialState,
        setShouldShowDescriptionPopup: (state, action: PayloadAction<boolean>) => {
            state.shouldShowDescriptionPopup = action.payload;
        },
        setDescriptionPopupData: (state, action: PayloadAction<CurrentCellData>) => {
            state.cellDescriptionData = action.payload;
        },
        setStatsExpanded: (state, action: PayloadAction<{ isExpanded: boolean }>) => {
            state.isStatsExpanded = action.payload.isExpanded;
        },
        setStudentOnline: (state, action: PayloadAction<{ studentId: StudentId; problemId: ProblemId }>) => {
            state.studentsOnline[action.payload.studentId] = action.payload.problemId;
        },
        updateLessonStats: () => {},
    },
});

export const resultsActions = slice.actions;
export const resultsReducer = slice.reducer;
